/**
 * Size Chart Component
 * @version 2.0.0
 */

(function() {
  'use strict';

  // The snippet can include this file more than once (several charts on a page,
  // quickshop HTML loaded later): only initialise the new charts.
  if (window.SizeChart) {
    window.SizeChart.init();
    return;
  }

  const STORAGE_KEY = 'size_chart_unit';
  const UNITS = ['inches', 'cm'];
  const DEFAULT_UNIT = 'inches';
  const SELECTORS = {
    chart: '[data-size-chart]',
    btn: '.size-chart__unit-btn',
    table: '[data-size-table]',
    // Single-unit tables render without data-table-unit and stay visible
    container: '.size-table__container[data-table-unit]'
  };

  class SizeChart {
    constructor(el) {
      this.el = el;
      this.btns = el.querySelectorAll(SELECTORS.btn);
      this.tables = el.querySelectorAll(SELECTORS.table);
      this.unit = this.getStoredUnit();
      
      if (!this.btns.length || !this.tables.length) return;
      
      this.init();
    }

    init() {
      this.btns.forEach(btn => {
        btn.addEventListener('click', this.handleClick.bind(this));
      });
      
      this.switchUnit(this.unit, false);
    }

    handleClick(e) {
      e.preventDefault();
      const unit = e.currentTarget.dataset.unit;
      if (UNITS.includes(unit) && unit !== this.unit) {
        this.switchUnit(unit, true);
      }
    }

    switchUnit(unit, save) {
      this.unit = unit;
      this.updateButtons(unit);
      this.updateTables(unit);
      
      if (save) this.saveUnit(unit);
      
      this.el.dispatchEvent(new CustomEvent('sizechart:change', {
        detail: { unit },
        bubbles: true
      }));
    }

    updateButtons(unit) {
      this.btns.forEach(btn => {
        const isActive = btn.dataset.unit === unit;
        btn.classList.toggle('size-chart__unit-btn--active', isActive);
        btn.setAttribute('aria-selected', isActive);
      });
    }

    updateTables(unit) {
      this.tables.forEach(table => {
        table.querySelectorAll(SELECTORS.container).forEach(container => {
          const show = container.dataset.tableUnit === unit;
          show ? container.removeAttribute('hidden') : container.setAttribute('hidden', '');
        });
      });
    }

    getStoredUnit() {
      try {
        const unit = localStorage.getItem(STORAGE_KEY);
        return UNITS.includes(unit) ? unit : DEFAULT_UNIT;
      } catch {
        return DEFAULT_UNIT;
      }
    }

    saveUnit(unit) {
      try {
        localStorage.setItem(STORAGE_KEY, unit);
      } catch {}
    }

    destroy() {
      this.btns.forEach(btn => {
        btn.removeEventListener('click', this.handleClick);
      });
    }
  }

  function init() {
    document.querySelectorAll(SELECTORS.chart).forEach(el => {
      if (!el._sizeChart) {
        el._sizeChart = new SizeChart(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }

  window.SizeChart = { init };
})();